import { useRef, VoidFunctionComponent } from 'react';
import { BufferGeometryLoader, DoubleSide, Group, ShaderMaterial } from 'three';
import { useLoader } from '@react-three/fiber';
import { buildPublicUrl } from '@/lib/globals';

export const humanURL = buildPublicUrl(`3d/human.json`);
const threeGroup = new Group();

const vertexShader = `
attribute vec3 center;
varying vec3 vCenter;

void main() {
    vCenter = center;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`;

const fragmentShader = `
uniform float thickness;
varying vec3 vCenter;

void main() {
    vec3 afwidth = fwidth( vCenter.xyz );
    vec3 edge3 = smoothstep( ( thickness - 1.0 ) * afwidth, thickness * afwidth, vCenter.xyz );
    float edge = 1.0 - min( min( edge3.x, edge3.y ), edge3.z );
    gl_FragColor.rgb = gl_FrontFacing ? vec3( 1.0, 1.0, 1.0 ) : vec3( 0.1, 0.1, 0.1 );
    gl_FragColor.a = gl_FrontFacing ? edge : 0.0;
}`;

const material = new ShaderMaterial({
    uniforms: { thickness: { value: 1 } },
    vertexShader,
    fragmentShader,
    side: DoubleSide,
    alphaToCoverage: true, // only works when WebGLRenderer's "antialias" is set to "true"
});
material.extensions.derivatives = true;

export const Human: VoidFunctionComponent = ({ ...props }: JSX.IntrinsicElements['group']) => {
    const group = useRef<THREE.Group>(threeGroup);
    const geometry = useLoader(BufferGeometryLoader, humanURL);
    return (
        <group scale={1.5} position={[0, -0.3, 0]} rotation={[0, Math.PI, 0]} ref={group} {...props} dispose={null}>
            <mesh geometry={geometry} material={material} />
        </group>
    );
};
